export default {
  APP_NAME: 'KeymarkDB',
  APP_ENV: 'live',
  APP_URL: 'https://api.certificates.keymark.eu'
}
